export default [
  {
    path: "/app/403",
    name: "app.forbidden",
    component: () => import("../views/Forbidden.vue"),
    meta: {
      title: "Educasis - Acesso não permitido",
      requiresAuth: true,
    },
  },
];
